import {apiPost} from "./General";

export const formSubmit = (body, cb, ecb) => {
    apiPost('users/enews', body, cb, ecb);
}